import * as Dtos from '../../dtos/Tmd.dtos';

export const
    setEditModalViewState: IGroupItemsPageSetEditModalViewStateActionCreator = (open, collectionInstanceId, name, description) => {
        return {
            type: ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
            open,
            collectionInstanceId,
            name,
            description
        }
    },
    setCreateVersionModalViewState: IGroupItemsPageSetCreateVersionModalViewStateActionCreator = (open, groupItem) => {
        return {
            type: ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE,
            open,
            groupItem
        }
    }

export const
    ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE = "ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE = "ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE"

/* Actions */

export interface IGroupItemsPageSetEditModalViewStateAction {
    type: "ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    open: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

export interface IGroupItemsPageSetCreateVersionModalViewStateAction {
    type: "ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE",
    open: boolean;
    groupItem: Dtos.GroupItem
}

/* Action Creators */

export interface IGroupItemsPageSetEditModalViewStateActionCreator {
    (
        open: boolean,
        collectionIntanceId: number,
        name: string,
        description: string
    ): IGroupItemsPageSetEditModalViewStateAction;
}

export interface IGroupItemsPageSetCreateVersionModalViewStateActionCreator {
    (
        open: boolean,
        groupItem: Dtos.GroupItem
    ): IGroupItemsPageSetCreateVersionModalViewStateAction;
}


/* Final Export of actions */
export type GroupItemsPageAction =
    IGroupItemsPageSetEditModalViewStateAction |
    IGroupItemsPageSetCreateVersionModalViewStateAction;
